import { composePaths, createDefaultValue } from "@jsonforms/core";
import { withJsonFormsArrayLayoutProps } from "@jsonforms/react";
import { Stack, Typography } from "@mui/material";
import _isEqual from "lodash/isEqual";
import { Button } from "pepsico-ds";
import { memo, useCallback } from "react";
import { CardRendererControl } from "./CardRenderer";

const ArrayLayoutRendererComponent = (props) => {
  const {
    uischema,
    schema,
    label,
    renderers,
    cells,
    data,
    path,
    addItem,
    removeItems,
    enabled,
  } = props;
  const addItemCb = useCallback((p, value) => addItem(p, value), [addItem]);

  const removeItemsCb = useCallback(
    (path, toDelete) => (removeItems ? removeItems(path, toDelete) : () => {}),
    [removeItems]
  );

  const toRender = Array(data)
    .fill(0)
    .map((_, i) => (
      <CardRendererControl
        key={i}
        index={i}
        schema={schema}
        uischema={uischema}
        path={composePaths(path, `${i}`)}
        renderers={renderers}
        cells={cells}
        onRemove={removeItemsCb(path, [i])}
        label={label}
        enabled={enabled}
      />
    ));
  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mt={2}
      >
        <Typography color="black" fontWeight="medium" fontSize="12px">
          {label}
        </Typography>
        <Button
          size="small"
          disabled={!enabled}
          onClick={addItemCb(path, createDefaultValue(schema))}
        >
          Add {label}
        </Button>
      </Stack>
      {data > 0 ? toRender : <Typography>No {label} added</Typography>}
    </div>
  );
};

export const ArrayLayoutRendererControl = memo(
  withJsonFormsArrayLayoutProps(ArrayLayoutRendererComponent),
  (prevProps, props) => _isEqual(prevProps, props)
);
